import OngoingRules from './ruleTypesForm/OngoingRulesForm';
import RequestRules from './ruleTypesForm/RequestRulesForm';
import ruleType from '../../constants/ruleTypes';

const ruleTypeMapper = {
  [ruleType.REQUEST]: RequestRules,
  [ruleType.ONGOING]: OngoingRules,
};

export default ruleTypeMapper;
